module.exports = __webpack_public_path__ + "static/img/kurt.da187d5a.jpg";